module.exports = __webpack_public_path__ + "img/device_65les_r1.bec42da9.png";